import type { Currency } from "../../shared/constants";
import { formatPrice } from "../../shared/money";

/** "1 produs" / "3 produse" — Romanian count phrases as in the prototype. */
export const plural = (n: number, one: string, many: string) => (n === 1 ? `1 ${one}` : `${n} ${many}`);

/** Prototype-style moments: "azi, 10:42", "ieri, 21:15", otherwise "21 oct., 10:42". */
export function formatWhen(ms: number | null | undefined, now = new Date()): string {
  if (!ms) return "";
  const d = new Date(ms);
  const time = new Intl.DateTimeFormat("ro-RO", { hour: "2-digit", minute: "2-digit" }).format(d);
  const day = (x: Date) => new Date(x.getFullYear(), x.getMonth(), x.getDate()).getTime();
  const diff = Math.round((day(now) - day(d)) / 86_400_000);
  if (diff === 0) return `azi, ${time}`;
  if (diff === 1) return `ieri, ${time}`;
  return `${new Intl.DateTimeFormat("ro-RO", { day: "numeric", month: "short" }).format(d)}, ${time}`;
}

export const price = (minor: number | null, currency: Currency) =>
  minor === null ? "—" : formatPrice(minor, currency, "ro");

export const currencySymbol = (c: Currency) => (c === "EUR" ? "€" : "lei");

export const currencyWord = (c: Currency) => (c === "EUR" ? "euro" : "lei");

/** A steady tint (1–5) for a product without a photo, so the same dish keeps its colour (DEC-130). */
export function monoTone(name: string): number {
  let h = 0;
  for (const ch of name) h = (h * 31 + (ch.codePointAt(0) ?? 0)) >>> 0;
  return (h % 5) + 1;
}

export function initialsOf(name: string): string {
  return (
    name
      .split(/\s+/)
      .filter(Boolean)
      .slice(0, 2)
      .map((w) => w[0]?.toUpperCase() ?? "")
      .join("") || "M"
  );
}
